import React from 'react';

import Container from '../../components/Container/Container';

import maidOfHonor from '../../assets/wedding-party/geri.JPG';
import bestman from '../../assets/wedding-party/mladen.jpg';
import PersonCard from '../../components/PersonCard/PersonCard';
import headingImage from '../../assets/heading-image-3.jpg'
import headingImage2 from '../../assets/heading-image-4.jpg'

import styles from './WeddingParty.module.scss';

import {BRIDESMAIDS, GROOMSMEN} from '../../config';
import Page from '../../components/Page';

const WeddingParty = () => {
    return (
        <Page title="Kумове & Шафери">
            <Container className={styles.container} center>
                <h2>Кумуват</h2> 
                <div className={styles.bestPeople}>
                    <PersonCard className={styles.bestPerson} imageSrc={maidOfHonor} name="Гергана Енева" description="Гери е близка приятелка от студентските години. Лъчезарна, щура и винаги готова за приключения." simple />
                    <PersonCard className={styles.bestPerson} imageSrc={bestman} name="Младен Карадимов" description="Младен е верен приятел от ТУЕС. Сладкодумен, весел и душата на компанията." simple />
                </div>  
            </Container>

            <Container className={styles.bridesmaid} center>
                <img alt="heading-img" src={headingImage2} width={200} />
                <h2>Шаферки</h2>
                <div className={styles.list}>
                    {BRIDESMAIDS.map((bridesmaid) => (
                        <PersonCard key={bridesmaid.name} imageSrc={bridesmaid.src} name={bridesmaid.name} simple size="small" />
                    ))}
                </div>
            </Container>

            <Container className={styles.bridesmaid} center>
                <img alt="heading-img" src={headingImage} width={200} />
                <h2>Шафери</h2>
                <div className={styles.list}>
                    {GROOMSMEN.map((groomsman) => (
                        <PersonCard key={groomsman.name} imageSrc={groomsman.src} name={groomsman.name} simple size="small" />
                    ))}
                </div>
            </Container>
        </Page>
    )
}

export default WeddingParty;